<template>
  <v-container
    grid-list-md
    px-5
    pt-1
    ma-2
    pb-5
    style="max-width: calc(100% - 16px)"
    data-test="sender-manager-page"
  >
    <v-expand-transition>
      <v-layout v-show="selectedInitiativesUpdate.length < 1" row wrap>
        <v-flex xs12 sm6 md3 lg2>
          <v-select
            v-model="active"
            :items="activeItems"
            label="Ativo/Inativo"
            item-text="name"
            item-value="value"
            @change="handleFilterChange"
            box
            flat
            success
          ></v-select>
        </v-flex>
        <!-- <v-flex xs12 sm6 md3 lg2>
          <v-select
            v-model="statusSelected"
            :items="statusOptions"
            label="Status"
            item-text="name"
            item-value="value"
            @change="handleFilterChange"
            box
            flat
            success
            clearable
          ></v-select>
        </v-flex> -->

        <v-flex xs12 sm6 md4 lg2> </v-flex>
      </v-layout>
    </v-expand-transition>
    <v-alert :value="error" type="error">
      Erro
      <v-btn @click="getPhoneSenders()">Tentar novamente</v-btn>
    </v-alert>
    <v-data-table
      :total-items="numResults"
      :items="phoneSenders"
      :disable-initial-sort="true"
      :pagination.sync="pagination"
      :rows-per-page-items="[10, 25, 50, 100]"
      :hide-actions="false"
      :loading="loading"
      :headers="headers"
      v-model="selectedInitiativesUpdate"
      class="mb-4"
      @update:pagination="getPhoneSenders()"
      v-if="!error"
    >
      <template v-slot:items="props">
        <tr data-test="sender-row" style="max-height: fit-content">
          <td style="max-width: fit-content">
            <v-layout d-flex column style="max-width: fit-content">
              <span
                class="text-no-wrap d-flex flex-row align-center"
                style="width: min-content"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="d-flex flex-row align-center"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        size="10"
                        :color="props.item.active ? '#4caf50' : '#f44336'"
                      >
                        mdi-circle
                      </v-icon>
                      <span
                        class="d-inline-block caption text-xs-left grey--text text--darken-1"
                        style="width: 24px"
                      >
                        #{{ props.item.id }}
                      </span>
                    </span>
                  </template>
                  {{ props.item.active ? "Ativo" : "Inativo" }}
                </v-tooltip>
                <b>
                  {{ props.item.phone_number | phoneNumber }}
                </b>
                <FlaggedIcon
                  v-if="
                    props.item.meta_status &&
                    props.item.meta_status === 'FLAGGED'
                  "
                ></FlaggedIcon>
              </span>

              <OwnerChip :owner="props.item.owner"></OwnerChip>
            </v-layout>
          </td>

          <!-- Owner -->
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <p
                  class="meta-ids text-no-wrap grey--text text--darken-1"
                  v-bind="attrs"
                  v-on="on"
                  @click="copyId('Meta', props.item.meta_phone_number_id)"
                >
                  {{ props.item.meta_phone_number_id || "--" }}
                  <v-icon class="copy-icon" size="14">mdi-content-copy</v-icon>
                </p>
              </template>
              <span>MetaID</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <p
                  class="meta-ids text-no-wrap mt-1 grey--text text--darken-1"
                  v-bind="attrs"
                  v-on="on"
                  @click="copyId('WABA', props.item.meta_waba_id)"
                >
                  {{ props.item.meta_waba_id || "--" }}
                  <v-icon class="copy-icon" size="14">mdi-content-copy</v-icon>
                </p>
              </template>
              <span>WABA</span>
            </v-tooltip>
          </td>

          <!-- Status -->
          <td style="min-width: 124px !important">
            <SenderStatusChip
              :status="props.item.status"
              :tooltip="props.item.status_cause"
              :options="statusOptions"
              :enableEdit="isSenderAdmin"
              :disabled="!isSenderAdmin"
              @click="
                showChangeStatusDialog = true;
                senderToChange = props.item;
              "
            />
          </td>

          <!-- Qualidade -->
          <td>
            <v-layout
              d-flex
              column
              justify-center
              align-center
              pa-2
              data-test="sender-quality-chip"
              style="gap: 1px; width: min-content"
            >
              <QualityChip
                tooltip="Ver Histórico"
                @click="viewHistory(props.item)"
                :quality="props.item.meta_quality_rating_v2"
                clickable
              />
            </v-layout>
          </td>

          <!-- credores -->
          <td>
            <CreditorsDisplay
              :creditors="props.item.credores"
              :all-creditors="creditors"
            ></CreditorsDisplay>
          </td>

          <!-- enfileirados -->
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="d-flex flex-row align-center text-no-wrap"
                >
                  <v-icon size="16" style="max-width: min-content">
                    mdi-tray-full
                  </v-icon>
                  <span class="ml-1">
                    {{ props.item.enfileirado | formatBigNumber }}
                  </span>
                </div>
              </template>
              <span>Enfileirados</span>
            </v-tooltip>
          </td>

          <!-- enviados -->
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="d-flex flex-row align-center text-no-wrap py-1 px-2"
                  :style="{
                    backgroundColor: props.item.bgColor,
                    maxWidth: 'min-content',
                    borderRadius: '4px',
                  }"
                >
                  <v-icon
                    size="14"
                    :color="props.item.color"
                    style="max-width: min-content"
                  >
                    mdi-send
                  </v-icon>
                  <span
                    class="font-weight-bold ml-2"
                    :style="{ color: props.item.color }"
                  >
                    {{ props.item.enviados | formatBigNumber }}
                  </span>
                </span>
              </template>
              <span>Enviados</span>
            </v-tooltip>
          </td>

          <!-- Última atualização -->
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="text-no-wrap">
                  {{ props.item.updated_at | formatDateTime }}
                </span>
              </template>
              <span>{{ props.item.updated_at | formatDateAgo }}</span>
            </v-tooltip>
          </td>

          <td class="px-0" style="max-width: min-content">
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  class="btn-hover-reveal"
                  style="width: 30px"
                  v-bind="attrs"
                  v-on="on"
                  small
                  flat
                  icon
                  color="grey"
                  @click="viewInitiatives(props.item)"
                >
                  <v-icon>send_to_mobile</v-icon>
                </v-btn>
              </template>
              <span>Ver Iniciativas</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <SenderHistoryDialog
      v-model="showHistoryDialog"
      :items="historyItems"
      :loading="loadingHistory"
      :sender="historySelectedSender"
      :status-options="statusOptions"
    ></SenderHistoryDialog>

    <ChangeStatusDialog
      v-model="showChangeStatusDialog"
      :sender="senderToChange"
      :options="statusOptions"
      @save="saveSenderStatus"
      @close="
        showChangeStatusDialog = false;
        senderToChange = null;
      "
    ></ChangeStatusDialog>

    <MetaDetailDialog v-model="metaDetailDialog" :data="metaDetailToShow" />

    <v-snackbar v-model="showSnack" :timeout="2000" top>
      {{ snackMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
import PhoneSenderService from "@/services/consolidation-tree/phone-senders";
import creditorService from "@/services/creditor";

// global components
import SelectCreditors from "@/components/creditor/SelectCreditors";
import SenderSelector from "@/components/senderSelector.vue";
import FlaggedIcon from "@/components/ui/FlaggedIcon.vue";
import ProgressBar from "@/components/ui/ProgressBar.vue";
import QualityChip from "@/components/ui/QualityChip.vue";
import OwnerChip from "@/components/ui/OwnerChip.vue";

// components
import SenderStatusChip from "./components/SenderStatusChip.vue";
import SenderHistoryDialog from "./components/SenderHistoryDialog.vue";
import MetaDetailDialog from "./components/MetaDetailDialog.vue";
import ChangeStatusDialog from "./components/ChangeStatusDialog.vue";
import CreditorsDisplay from "./components/CreditorsDisplay.vue";

const STATUS_OPTIONS = [
  {
    name: "Ativo",
    shortname: "Ativo",
    value: "ACTIVE",
    color: "#4caf50",
    icon: "mdi-check",
  },
  {
    name: "Inativo",
    shortname: "Inativo",
    value: "INACTIVE",
    color: "#f44336",
    icon: "mdi-close",
  },
  {
    name: "Temporariamente Inativo",
    shortname: "Inativo *",
    value: "TEMPORARY_INACTIVE",
    color: "#ff9800",
    icon: "mdi-clock-alert-outline",
  },
];

const PROGRESS_COLORS = [
  "#1b5e20",
  "#2e7d32",
  "#33691e",
  "#558b2f",
  "#827717",
  "#9e9d24",
  "#fbc02d",
  "#f9a825",
  "#f57f17",
  "#ff9800",
  "#fb8c00",
  "#f57c00",
  "#ef6c00",
  "#e65100",
  "#ef5350",
  "#e53935",
  "#d32f2f",
  "#c62828",
  "#b71c1c",
];

export default {
  components: {
    SelectCreditors,
    SenderSelector,
    SenderHistoryDialog,
    MetaDetailDialog,
    QualityChip,
    OwnerChip,
    FlaggedIcon,
    SenderStatusChip,
    ChangeStatusDialog,
    ProgressBar,
    CreditorsDisplay,
  },
  data() {
    return {
      searchValue: null,
      searchTimer: null,
      loading: false,
      numResults: 0,
      phoneSenders: [],
      pagination: {
        rowsPerPage: 25,
        page: 1,
        sortBy: "id",
        descending: true,
      },
      headers: [
        { text: "ID / Número", value: "id", sortable: true },
        { text: "MetaID / WABA", value: "owner", sortable: false },
        {
          text: "Status",
          value: "status",
          sortable: true,
        },
        {
          text: "Qualidade",
          value: "meta_quality_rating_v2",
          sortable: true,
        },
        {
          text: "Credores",
          value: "credores",
          sortable: false,
        },
        {
          text: "Enfileirados",
          value: "enfileirado",
          sortable: false,
          class: "td-no-padding td-queue",
        },
        {
          text: "Enviados",
          value: "enviados",
          sortable: false,
          class: "td-no-padding td-queue",
        },
        {
          text: "Última atualização",
          value: "updated_at",
          sortable: true,
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "right",
          width: "30px",
        },
      ],
      active: null,
      activeItems: [
        { name: "Todos", value: null },
        { name: "Ativo", value: true },
        { name: "Inativo", value: false },
      ],
      statusSelected: null,
      statusOptions: STATUS_OPTIONS,
      selectedInitiativesUpdate: [],
      selectAllCheckbox: false,
      unselectInitiatives: false,
      creditors: [],
      loadingSenders: false,
      loadingSendersError: false,
      senderAux: null,
      senders: [],
      showSnack: false,
      snackMessage: "",
      error: false,
      showHistoryDialog: false,
      historyItems: [],
      loadingHistory: false,
      historySelectedSender: null,
      metaDetailToShow: null,
      metaDetailDialog: false,
      showChangeStatusDialog: false,
      senderToChange: null,
    };
  },
  computed: {
    isSenderAdmin() {
      return (
        this.$store.getters.getLoggedUser.roles.includes("sender_admin")
      );
    },
  },

  created() {
    const query = {
      ...this.getCurrentParams(),
      ...this.$route.query,
    };

    this.applyQuery(query);
    this.getCreditors();
  },

  methods: {
    async getCreditors() {
      await creditorService
        .list()
        .then((res) => {
          this.creditors = res.objects;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getPhoneSenders() {
      const params = this.getCurrentParams();
      this.error = false;
      this.loading = true;

      return PhoneSenderService.listPhoneSenders(params)
        .then((response) => {
          this.phoneSenders = response.objects.map((sender) => {
            return {
              ...sender,
              status: sender.status || (sender.active ? "ACTIVE" : "INACTIVE"),
            };
          });
          this.setColors();
          this.numResults = response.num_results;
        })
        .catch((e) => {
          console.error(e);
          this.error = true;
          this.snackMessage = "Erro ao buscar os dados!";
          this.showSnack = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setColors() {
      const highest = Math.max(
        ...this.phoneSenders.map((sender) => sender.enviados || 0),
      );

      this.phoneSenders = this.phoneSenders.map((sender) => {
        const color = this.getProgressColor(sender.enviados || 0, highest);
        let bgColor = "rgba(255, 255, 255, 0.3)";
        if (color) {
          const r = parseInt(color.slice(1, 3), 16);
          const g = parseInt(color.slice(3, 5), 16);
          const b = parseInt(color.slice(5, 7), 16);
          bgColor = `rgba(${r}, ${g}, ${b}, 0.3)`;
        }
        return {
          ...sender,
          color,
          bgColor,
        };
      });
    },

    getProgressColor(enviados, highest) {
      const percentage = (enviados || 0) / highest;
      if (percentage <= 0 || isNaN(percentage)) return PROGRESS_COLORS[0];
      if (percentage >= 1) return PROGRESS_COLORS[PROGRESS_COLORS.length - 1];

      const i = Math.floor(percentage * (PROGRESS_COLORS.length - 1));

      return PROGRESS_COLORS[i];
    },

    getCurrentParams() {
      let params = {
        include_daily_metrics: true,
        //pagination
        page: this.pagination.page || 1,
        limit: this.pagination.rowsPerPage || 25,
        order:
          !this.pagination.descending && this.pagination.sortBy
            ? "-" + this.pagination.sortBy
            : this.pagination.sortBy || "",
        //filters
        active: this.active,
      };

      if (this.statusSelected) params.status = this.statusSelected;

      Object.keys(params).forEach((k) => {
        if (params[k] === null) delete params[k];
      });

      return params;
    },

    pushQueryInUrl(obj) {
      const newQuery = { ...obj };
      for (const key in newQuery) {
        const val = newQuery[key];
        if (val === null || val === undefined || String(val) === "NaN")
          delete newQuery[key];
      }
      this.$router.push({ query: newQuery });
    },

    applyQuery(query) {
      if (query.search) {
        this.searchValue = query.search;
      }

      if (query.active !== undefined) {
        this.active = query.active === "false" ? false : true;
      }

      if (this.$route.query.order) {
        const descending = !this.$route.query.order.startsWith("-");
        this.pagination.descending = descending;
        this.pagination.sortBy = descending
          ? this.$route.query.order
          : this.$route.query.order.slice(1);
      }
    },

    handleSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.handleFilterChange();
      }, 500);
    },
    handleFilterChange() {
      this.pagination.page = 1;
      this.getPhoneSenders();
    },
    viewInitiatives(sender) {
      this.$router.push({
        name: "Gerenciador de iniciativas",
        query: { phone_sender_id: sender.id, active: sender.active },
      });
    },
    viewHistory(sender) {
      if (this.loadingHistory || this.loading) return;

      this.loadingHistory = true;
      this.showHistoryDialog = true;
      this.historySelectedSender = sender;

      PhoneSenderService.getHistory(sender.id)
        .then((response) => {
          this.historyItems = response.objects;
        })
        .finally(() => {
          this.loadingHistory = false;
        });
    },

    openMetaDetail(metaDetail) {
      this.metaDetailToShow = metaDetail;
      this.metaDetailDialog = true;
    },

    saveSenderStatus(statusNewData) {
      this.loading = true;
      this.showChangeStatusDialog = false;
      PhoneSenderService.updateStatus(this.senderToChange.id, statusNewData)
        .then((senderUpdated) => {
          this.phoneSenders = this.phoneSenders.map((sender) =>
            sender.id === senderUpdated.id
              ? {
                  ...sender,
                  status: senderUpdated.status,
                  status_cause: senderUpdated.status_cause,
                  updated_at: senderUpdated.updated_at,
                  active: senderUpdated.active,
                }
              : sender,
          );

          this.$store.commit("showSnackbar", {
            message: "Status do remetente atualizado com sucesso!",
            color: "success",
          });
        })
        .catch((e) => {
          console.error(e);
          this.$store.commit("showSnackbar", {
            message: "Não foi possível atualizar o status do remetente",
            color: "error",
          });
        })
        .finally(() => {
          this.loading = false;
          this.senderToChange = null;
        });
    },

    copyId(type, id) {
      navigator.clipboard.writeText(id).then(() => {
        this.$store.commit("showSnackbar", {
          message: `${type} ID copiado para a área de transferência!`,
          color: "green",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-datatable tbody tr:hover {
  background-color: #f5f5f5 !important;
}
::v-deep table.v-table tbody td:first-child {
  padding: 10px !important;
}

.btn-hover-reveal {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease-in-out;
}

tr:hover .btn-hover-reveal {
  opacity: 1;
  visibility: visible;
}

.copy-icon {
  position: absolute;
  margin-left: 4px;
  display: none;
}
.meta-ids {
  cursor: pointer;
  position: relative;
}
.meta-ids:hover .copy-icon {
  display: inline-block;
}
.copy-icon:hover {
  display: inline-block;
}
</style>
